import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { PropTypes } from "prop-types";
import React, { useRef } from "react";

const IconInput = ({
  iconPrefix = "far",
  icon,
  side = "left",
  className = "",
  containerClassName = "",
  ...props
}) => {
  const classes = classNames(side === "left" ? "pl30" : "", className);
  const inputRef = useRef(null);

  const handleIconClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className={classNames("form-group has-feedback", containerClassName)}>
      <FontAwesomeIcon
        icon={[`${iconPrefix}`, `fa-${icon}`]}
        className={`form-control-feedback form-control-feedback-${side}`}
        onClick={handleIconClick}
      />
      <input ref={inputRef} className={classes} {...props} />
    </div>
  );
};

IconInput.propTypes = {
  icon: PropTypes.string.isRequired,
  iconPrefix: PropTypes.string,
  side: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default IconInput;
